export default class NotificationService {
  constructor() { }

  connect() {
    throw Error('Virtual method');
  }

  isConnected() {
    throw Error('Virtual method');
  }

  subscribe(topic, messageHandler) {
    throw Error('Virtual method');
  }

  disconnect() {
    throw Error('Virtual method');
  }
}
